module.exports = __webpack_public_path__ + "app_store_badge.2cb3595.png";